module.exports = {
  taxonomy: require('./src/taxonomy'),
  promise: require('./src/promise'),
  genetree: require('./src/genetree'),
  extensions: require('./src/treemodelExtensions')
};
